import React from 'react';
import ButtonsSearch from '../../../../../../../../components/NovoSistema/ButtonsSearch';
import { ContainerSection } from '../../../../../../../../components/NovoSistema/ContainerSection';
import InputText from '../../../../../../../../components/NovoSistema/InputText';
import SelectAndOptions from '../../../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import Legends from '../../../../../../../../components/NovoSistema/Legends';

export default function LocalizacaoSearch() {
  return (
    <div>
      <ContainerSection>
        <h3>Pesquisa</h3>
        <WrapperInputsNewSystem>
          <InputText title="Código" id="CodeProduto" widthPercentage="20%" />
          <InputText title="Descrição" id="DescricaoProduto" widthPercentage="40%" />
          <SelectAndOptions
            title="Situacao"
            id="Situacao"
            optionsArray={['', 'Ativo', 'Inativo']}
            widthPercentage="20%"
          />
        </WrapperInputsNewSystem>
        <ButtonsSearch />
      </ContainerSection>
      <ContainerSection>
        <h3>Legenda</h3>
        <Legends
          itens={[
            { text: 'Ativo', color: 'green' },
            { text: 'Inativo', color: 'red' },
          ]}
        />
      </ContainerSection>
    </div>
  );
}
